export default {
  common: {
    menu_about: 'About',
    menu_sponsor: 'Registration and Sponsorship',
    menu_venue: 'Venue',
    menu_agenda: 'Agenda',
    menu_system: 'E-Brochures Zone',
    menu_view: 'View Gallery',
    city_macao: 'Macao',
    city_zhuhai: 'Zhuhai',
  },
  home: {
    hello: 'Hello~',
    header_title1: 'GEA 10th',
    header_title2: 'Annual Conference',
    header_date: '19-22 February 2023 | Xiamen, Fujian',
    header_city: 'Xiamen Tefang Portman Seven Stars Bay Hotel & Resort',
    about: 'About',
    about_header: 'A place for learning, discovery, innovation, expression and discourse',
    about_section1_title1: '600+ Delegates',
    about_section1_text1: 'from 300 organizations',
    about_section2_title2: '400+ Counselors',
    about_section2_text2: "GEA's top performing channel partners",
    about_section3_title3: '80% Attendees',
    about_section3_text3: 'have more than five years experience in the field',
    discover_more: 'More →',
    sponsor_header: 'Come and join the largest international education recruiters event, sponsorship available',
  },
  about: {
    aboutTitle4_1: 'By attending our conference you will benefit from the following:',
    aboutContent4_1: 'Grand and joyful',
    aboutContent4_2: 'Enjoying a cutting-edge event organizing.',
    aboutContent4_3: 'Renowned speakers',
    aboutContent4_4: 'Listen to the most innovative ideas and get insightful analysis.',
    aboutContent4_5: 'Special featured events',
    aboutContent4_6: 'Share knowledge, Experience and Learn More.',
    aboutContent4_7: 'Networking',
    aboutContent4_8: 'Highly interaction on/off the party.',
    aboutContent4_9: 'Experience and taste of Xiamen',
    aboutContent4_10: 'Admire the extraordinary architecture and the delicious local cuisine.',
    aboutTitle5_1: 'Who Attends?',
    aboutContent5_1: 'The conference attracts professionals and decision makers from education organizations, international schools, education providers and representatives from public/government authorities.',
    aboutContent5_2: '600+ delegates from 300 organizations.',
    aboutContent5_3: "400+ GEA's top performing channel partners counselors.",
    aboutContent5_4: 'Approximately 80% of the attendees have more than five years experience in the field.',
    aboutContent5_5: 'Be part of the conference',
    aboutContent5_6:'98.78% of Delegates are interested in attending the next event.',
  },
  agenda: {
    agendaTitle1_1: 'GEA 10th Annual Conference Agenda',
    date1: 'Sunday, 19th February 2023',
    time1_1: '12:00-14:00',
    agenda1_1: 'Arrival and Check-in',
    time1_2: '15:00-18:00',
    agenda1_2: 'Keynote Speech by Official Authorities',
    time1_3: '19:00-20:30',
    agenda1_3: 'Welcome Reception Dinner – Casual',
    time1_4: '20:30-22:30',
    agenda1_4: 'Egret Island Cup Football Game',

    date2: 'Monday, 20th February 2023',
    time2_1: '09:00-10:30',
    agenda2_1: 'Keynote Speech',
    time2_2: '10:30-12:00',
    agenda2_2: 'Speed Dating',
    time2_3: '12:00-12:30',
    agenda2_3: 'Group Photograph',
    time2_4: '12:30-14:00',
    agenda2_4: 'Buffet Lunch',
    time2_5: '14:00-17:30',
    agenda2_5: ' Part I: Speed Dating',
    time2_6: '15:00-17:00',
    agenda2_6: 'Part II: Roundtable Meeting with Official Authorities, School Reps and VIP Agents',
    time2_7: '18:30-21:30',
    agenda2_7: 'Seafood Feast',

    date3: 'Tuesday, 21st February 2023 ',
    time3_1: '09:00-10:30',
    agenda3_1: 'Keynote Speech',
    time3_2: '10:30-12:00',
    agenda3_2: 'Speed Dating',
    time3_3: '12:00-14:00',
    agenda3_3: 'Buffet Lunch',
    time3_4: '14:00-17:30',
    agenda3_4: 'Part I: Speed Dating',
    time3_5: '15:00-17:00',
    agenda3_5: 'Part II: Roundtable Meeting with Official Authorities, School Reps and International Schools',
    time3_6: '19:30-21:30',
    agenda3_6: 'Charity Night',
    time3_7: '22:00-24:00',
    agenda3_7: 'After Party',

    date4: 'Wednesday, 22nd February 2023',
    time4_1: '09:00-12:00',
    agenda4_1: 'Free time, Wrap-up & Hotel Check out',
  },
  system: {
    systemTitle1_1: '2021 Abstracts & Brochures Upload',
    systemContent1_1: 'We strive for a green paperless annual conference this year. We would appreciate it if you could log into the online platform to upload materials of your institution (PPT, PDF, etc.) before the conference begins, so that the participating counselors can scan the QR code to download the materials. This will not only reduce the cost of mailing the materials, but also enhance training experience of the participants and achieve our goal of energy saving and environmental protection.',
    systemTitle2_1: 'E-Brochures Zone',
    systemContent2_1: 'E-Brochures Zone opens in February.',
    systemContent2_2: 'The following information should be prepared and submitted through our E-Brochures Zone.',
    systemContent2_3: '1. The submission site will request the following information:',
    systemContent2_3_1: 'Institution Info',
    systemContent2_3_2: 'Key Abstract',
    systemContent2_4: '2. Prepare PPT/PDF files to upload to the web site. Please note that:',
    systemContent2_4_1: 'The size of every file should not exceed 10 MB',
    systemContent2_4_2: 'The PPT, PDF files to be presented in the training session of the Annual Conference are recommended, but if they are not ready to be uploaded prior to the training, you may do so after that',

  }
};
